let SwiperTop = new Swiper('.marquee-swiper', {
  loop: true,
  spaceBetween: 10,
  centeredSlides: false,
  speed: 6000,
  autoplay: {
    disableOnInteraction: false,
    delay: 1
  },
  freeMode: true,
  freeModeMomentum: false,
  slidesPerView: 'auto',
  allowTouchMove: false,
  breakpoints: {
    1600: {
      slidesPerView: 'auto'
    }
  }
});

let SwiperTopNew = new Swiper('.marquee-swiper-new', {
  loop: true,
  spaceBetween: 0,
  centeredSlides: false,
  speed: 5000,
  autoplay: {
    disableOnInteraction: false,
    delay: 1
  },
  breakpoints: {
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    320: {
      slidesPerView: 2.2,
      spaceBetween: 10,
    }
  }
});

let SwiperTopVolume = new Swiper('.marquee-swiper-volume', {
  loop: true,
  spaceBetween: 0,
  centeredSlides: false,
  speed: 15000,
  autoplay: {
    delay: 1
  },
  freeMode: true,
  freeModeMomentum: false,
  slidesPerView: 'auto',
  allowTouchMove: false,
  breakpoints: {
    1920: {
      slidesPerView: 'auto',
      spaceBetween: 29,
    },
    1440: {
      slidesPerView: 'auto',
      spaceBetween: 29,
    },
    640: {
      slidesPerView: 'auto',
      spaceBetween: 20,
    },
    320: {
      slidesPerView: 'auto',
      spaceBetween: 20,
    }
  }
});

let SwiperTopVolume2 = new Swiper('.feature-text', {
  loop: true,
  spaceBetween: 0,
  centeredSlides: false,
  speed: 30000,
  autoplay: {
    delay: 1
  },
  freeMode: true,
  freeModeMomentum: false,
  slidesPerView: 'auto',
  allowTouchMove: false,
  breakpoints: {
    1920: {
      slidesPerView: 'auto',
      spaceBetween: 29,
    },
    1440: {
      slidesPerView: 'auto',
      spaceBetween: 29,
    },
    640: {
      slidesPerView: 'auto',
      spaceBetween: 20,
    },
    320: {
      slidesPerView: 'auto',
      spaceBetween: 20,
    }
  }
});

// Collapsible Accordions (FAQs and Glossary Page)
const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");
accordionItemHeaders.forEach(accordionItemHeader => {
  accordionItemHeader.addEventListener("click", event => {
    accordionItemHeader.classList.toggle("active");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
    }
    else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});

// Stockists Page Tabs
function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Stockists Page Sidebar Active/Inactive links
const sections = document.querySelectorAll(".stockists-right-section[id]");
window.addEventListener("scroll", navHighlighter);
function navHighlighter() {
  let scrollY = window.pageYOffset;
  sections.forEach(current => {
    const sectionHeight = current.offsetHeight;
    if (window.innerWidth >= 768) {
      var sectionTop = current.offsetTop - 90;
    } else {
      var sectionTop = current.offsetTop - 330;
    }
    sectionId = current.getAttribute("id");
    if (
      scrollY > sectionTop &&
      scrollY <= sectionTop + sectionHeight
    ) {
      document.querySelector(".navigation a").classList.remove("active");
      document.querySelector(".navigation a[href*=" + sectionId + "]").classList.add("active");
    } else {
      document.querySelector(".navigation a[href*=" + sectionId + "]").classList.remove("active");
    }
  });
}

// Activate Screensaver on Idle Screen
let inactivityTime = function () {
  let time;
  let timer = document.querySelector('#screensaver-timer-input').value;
  window.onload = resetTimer;
  document.onload = resetTimer;
  document.onmousemove = resetTimer;
  document.onmousedown = resetTimer; // touchscreen press
  document.ontouchstart = resetTimer;
  document.onclick = resetTimer; // touchpad clicks
  document.onkeypress = resetTimer;
  document.addEventListener('scroll', resetTimer, true); // improved; see comments
  function logout() {
    // alert('test');
    document.querySelector(".screensaver-section").style.display = 'block';
    document.querySelector(".body-tag").style.overflow = 'hidden';
  }
  function resetTimer() {
    clearTimeout(time);
    time = setTimeout(logout, timer);
    document.querySelector(".screensaver-section").style.display = 'none';
    document.querySelector(".body-tag").style.overflow = 'visible';
  }
};
inactivityTime();


function accountdetails(event) {
  var data = event.getAttribute("data-path");
  for (let i = 0; i < document.querySelectorAll('.account-menu-item').length; i++) {
    document.querySelectorAll('.account-menu-item')[i].classList.remove("account-menu-item-active");
  }
  event.classList.add("account-menu-item-active");
  for (let i = 0; i < document.querySelectorAll('.customer__title').length; i++) {
    document.querySelectorAll('.customer__title')[i].classList.add("customer__title-hide");
  }
  document.querySelector(".customer__title[data-path='"+data+"']").classList.remove("customer__title-hide");
  for (let i = 0; i < document.querySelectorAll(".account-path-check").length; i++) {
    document.querySelectorAll(".account-path-check")[i].classList.add("account-path-hide");
  }
  document.querySelector(".account-path-check[data-path='"+data+"']").classList.remove("account-path-hide");
  for (let i = 0; i < document.querySelectorAll(".account-info [data-path]").length; i++) {
    document.querySelectorAll(".account-info [data-path]")[i].classList.add("displaynone");
  }
  document.querySelector(".account-info [data-path='"+data+"']").classList.remove("displaynone");
}

